/**
 * Feature Benefits Accordion — one open item; desktop image updates instantly with the active row.
 * Scoped per [data-fba-root] so multiple sections can coexist.
 */
(function () {
  function setStageImage(stageImg, url, alt) {
    if (!stageImg) return;
    stageImg.style.transition = 'none';
    stageImg.style.removeProperty('opacity');
    if (!url) {
      stageImg.style.opacity = '0';
      return;
    }
    stageImg.removeAttribute('srcset');
    stageImg.src = url;
    stageImg.alt = alt || '';
    stageImg.style.opacity = '1';
  }

  function initFba(root) {
    var items = root.querySelectorAll('[data-fba-item]');
    var stageImg = root.querySelector('[data-fba-stage-img]');
    if (!items.length) return;

    function setActive(index) {
      items.forEach(function (row, i) {
        var active = i === index;
        row.classList.toggle('is-active', active);
        var btn = row.querySelector('[data-fba-trigger]');
        if (btn) btn.setAttribute('aria-expanded', active ? 'true' : 'false');
        var panel = row.querySelector('.fba-accordion__panel');
        if (panel) panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      var row = items[index];
      if (!row) return;
      var imageUrl = row.getAttribute('data-fba-image-url') || '';
      var imageAlt = row.getAttribute('data-fba-image-alt') || '';
      setStageImage(stageImg, imageUrl, imageAlt);
    }

    items.forEach(function (row, index) {
      var btn = row.querySelector('[data-fba-trigger]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isMobile = window.innerWidth < 750;

        // ✅ MOBILE: toggle behavior
        if (isMobile && row.classList.contains('is-active')) {
            row.classList.remove('is-active');

            var panel = row.querySelector('.fba-accordion__panel');
            if (panel) panel.setAttribute('aria-hidden', 'true');

            var btn = row.querySelector('[data-fba-trigger]');
            if (btn) btn.setAttribute('aria-expanded', 'false');

            return;
        }

        // ✅ default behavior (desktop + mobile open new)
        setActive(index);
        });
    });

    var initial = parseInt(root.getAttribute('data-fba-initial') || '0', 10);
    if (Number.isNaN(initial) || initial < 0) initial = 0;
    if (initial >= items.length) initial = 0;
    setActive(initial);
  }

  function boot() {
    document.querySelectorAll('[data-fba-root]').forEach(initFba);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector('[data-fba-root]');
    if (root) initFba(root);
  });
})();
